import React from "react";
import { CheckCircle2 } from "lucide-react";
import ServicePage from "./ServicePage";
import lawnmaintance from "../../assets/images/jpg/lawnmaintance.jpeg";

const service = {
  title: "Lawn Maintenance",
  icon: CheckCircle2,
  image: lawnmaintance,
  description:
    "Scheduled lawn maintenance for clean edges, healthy growth, and a consistently tidy outdoor finish.",
  longText:
    "Healthy lawns need regular care. Our lawn maintenance service includes mowing, edging, trimming, seasonal advice, and practical upkeep for residential and commercial lawns. We keep your lawn looking sharp without taking time from your week.",
  points: [
    "Lawn mowing and edging",
    "Grass trimming and clean-up",
    "Routine maintenance visits",
    "Seasonal lawn care advice",
    "Residential lawn support",
    "Commercial lawn upkeep",
  ],
};

export default function LawnMaintenance() {
  return <ServicePage service={service} />;
}
